import { render, staticRenderFns } from "./StoreInfo.vue?vue&type=template&id=b16ca470&"
import script from "./StoreInfo.vue?vue&type=script&lang=js&"
export * from "./StoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./StoreInfo.vue?vue&type=style&index=0&id=b16ca470&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
